<template>
    <el-dialog title="商业险保单信息" :visible.sync="dialogVisible" width="400px">
        <el-form :model="form" ref="form" :rules="rules" label-width="120px" label-position="left">
            <el-form-item label="保单照片" prop="commercialInsurance">
                <up-img :file.sync="form.commercialInsurance" width="200" height="135"></up-img>
            </el-form-item>
            <el-form-item label="保单号" prop="commercialInsuranceNo">
                <el-input v-model="form.commercialInsuranceNo" placeholder="请输入保单号" :maxlength="30"></el-input>
            </el-form-item>
            <el-form-item label="保单起始日期" prop="commercialInsuranceStart">
                <el-date-picker v-model="form.commercialInsuranceStart" type="date"
                    placeholder="选择日期">
                </el-date-picker>
            </el-form-item>
            <el-form-item label="保单截止日期" prop="commercialInsuranceEnd">
                <el-date-picker v-model="form.commercialInsuranceEnd" type="date"
                    placeholder="选择日期">
                </el-date-picker>
            </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
            <el-button size="medium" @click="dialogVisible = false">取 消</el-button>
            <el-button size="medium" type="primary" @click="submitForm" :loading="loading">确 定</el-button>
        </div>
    </el-dialog>
</template>

<script>
export default {
    props: {
        visible: {
            type: Boolean,
            default: false
        },
        info: {
            type: Object,
            default: () => ({})
        },
        loading: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            dialogVisible: false,
            form: {
                commercialInsurance: '',
                commercialInsuranceNo: '',
                commercialInsuranceStart: '',
                commercialInsuranceEnd: '',
            },
            rules: {
                commercialInsurance: [
                    { required: true, message: '请上传保单照片', trigger: 'change' }
                ],
                commercialInsuranceNo: [
                    { required: true, message: '请输入保单号', trigger: 'change' }
                ],
                commercialInsuranceStart: [
                    { required: true, message: '请选择保单起始日期', trigger: 'change' }
                ],
                commercialInsuranceEnd: [
                    { required: true, message: '请选择保单截止日期', trigger: 'change' }
                ],
            }
        }
    },
    watch: {
        visible(val) {
            this.dialogVisible = val;
            if (val) {
                this.initForm();
            }
        },
        dialogVisible(val) {
            this.$emit('update:visible', val);
        }
    },
    methods: {
        initForm() {
            this.form = {
                commercialInsurance: this.info.commercialInsurance || '',
                commercialInsuranceNo: this.info.commercialInsuranceNo || '',
                commercialInsuranceStart: this.info.commercialInsuranceStart * 1000 || '',
                commercialInsuranceEnd: this.info.commercialInsuranceEnd * 1000 || '',
            };
        },
        submitForm() {
            this.$refs.form.validate((valid) => {
                if (valid) {
                    this.$emit('submit', this.form);
                }
            });
        }
    }
}
</script>
